import React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'var(--color-primary)',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-3',
    lg: 'w-8 h-8 border-4'
  };

  return (
    <div 
      className={`inline-block animate-spin rounded-full border-solid ${sizeClasses[size]} border-[${color}] border-t-transparent ${className || ''}`}
      role="status"
    aria-label="Loading"
    >
      <style>{`
        @keyframes spin {
          to { transform: 'rotate(360deg)' }
          from { transform: 'rotate(0deg)' }
        }
        @keyframes spin-reverse {
          to { transform: 'rotate(0deg)' }
          from { transform: 'rotate(360deg)' }
        }
        .animate-spin {
          animation: spin 1s linear infinite, spin-reverse 1s linear infinite 0.5s;
        }
      `}</style>
    </div>
  );
};
